const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_NAME':
      return { ...state, name: action.payload };
    case 'SET_PHONE_NUMBER':
      return { ...state, phoneNumber: action.payload };
    case 'SET_EMAIL':
      return { ...state, email: action.payload };
    case 'SET_GOAL_UID':
      return {
        ...state,
        goal_uid: action.payload.goal_uid,
        selectedClass: action.payload.name
      };
    case 'SET_ERRORS':
      return { ...state, errors: action.payload };
    case 'SET_FORM':
      return { ...state, form: action.payload };
    case 'TOGGLE_BOOKED_CLASS':
      return { ...state, open: action.payload };
    default:
      return state;
  }
};

export default reducer;
